import { AnimatePresence, motion } from 'motion/react';
import { useBroadcast } from './hooks/useBroadcast';

import { AdvtFullSize } from './components/AdvtFullSize/AdvtFullSize';
import { Advt } from './components/Advt/Advt';
import { Photo } from './components/Photo/Photo';
import { BgVideos } from './components/BgVideos/BgVideos';

import logo from './assets/images/logo.png';

function App() {
  const { currentState, currentMessage } = useBroadcast();

  return (
    <div className="app-wrapper">
      <AnimatePresence mode="wait">
        {currentState === 'S1' && (
          <motion.div
            key={`question`}
            className="question"
            initial={{
              transform:
                'perspective(156rem) rotateX(12deg) rotateY(20deg) rotateZ(-2deg)',
            }}
            animate={{
              transform:
                'perspective(156rem) rotateX(12deg) rotateY(-10deg) rotateZ(1deg)',
              transition: {
                duration: 2,
                repeat: Infinity,
                repeatType: 'reverse',
              },
            }}
            exit={{
              transform:
                'perspective(156rem) rotateX(12deg) rotateY(-10deg) rotateZ(1deg) scale(0)',
              transition: {
                duration: 0.5,
              },
            }}
          >
            <AdvtFullSize />
          </motion.div>
        )}

        {['S2', 'S3'].includes(currentState) && (
          <motion.div
            style={{
              width: '100%',
              height: '100%',
            }}
          >
            <Advt />
            <Photo
              currentState={currentState}
              message={currentMessage?.message}
            />
          </motion.div>
        )}
      </AnimatePresence>

      <BgVideos currentState={currentState} message={currentMessage?.message} />

      <img src={logo} alt="" className="preloadImg" />
    </div>
  );
}

export default App;
